import { createApiSlice } from "@common";
import { CRUD_NURTURE_REASON } from "@routes";

const apiConfig = [
  {
    name: "addNurtureReason",
    method: "post",
    url: CRUD_NURTURE_REASON,
    stateKey: "message"
  },
  {
    name: "getNurtureReason",
    method: "get",
    url: CRUD_NURTURE_REASON,
    stateKey: "data"
  },
  {
    name: "updateNurtureReason",
    method: "put",
    url: CRUD_NURTURE_REASON,
    stateKey: "message"
  },
  {
    name: "deleteNurtureReason",
    method: "delete",
    url: CRUD_NURTURE_REASON,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "nurtureReason",
  apiConfig,
  customReducers);
const nurtureReasonSlice = slice;

export default nurtureReasonSlice.reducer;

export const {
  addNurtureReason,
  getNurtureReason,
  updateNurtureReason,
  deleteNurtureReason } = thunks;
export const { rowSelect } = actions;
